import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const redirectFromHomeGuard: CanActivateFn = () => {
  const router = inject(Router);
  let url: string;

  router.events.subscribe((resp: any) => {
    (async () => {
      url = await resp.url;
    })();
  });

  let aux = 0;
  setTimeout(() => {
    if (url === '/home') {
      router.navigate(['/sign-in']);
      aux++;
    }
  }, 100);
  return aux === 0;
};
